/**
 * Pickup Locations API Client
 * Frontend API calls for managing pickup locations
 */

import { apiCall } from '../api';
import type {
  PickupLocation,
  CreatePickupLocationRequest,
  UpdatePickupLocationRequest,
  PickupLocationResponse,
  PickupLocationsResponse,
} from '@/types/api';

/**
 * Fetch all pickup locations
 * @param activeOnly - Only return active locations (default: true)
 */
export async function fetchPickupLocations(
  activeOnly: boolean = true
): Promise<PickupLocation[]> {
  const url = activeOnly
    ? '/api/pickup-locations'
    : '/api/pickup-locations?activeOnly=false';

  const data = await apiCall<PickupLocationsResponse>(url, {
    method: 'GET',
  });

  return data.locations;
}

/**
 * Create a new pickup location (Admin only)
 */
export async function createPickupLocation(
  data: CreatePickupLocationRequest
): Promise<PickupLocation> {
  const response = await apiCall<PickupLocationResponse>('/api/pickup-locations', {
    method: 'POST',
    body: JSON.stringify(data),
  });

  return response.location;
}

/**
 * Update an existing pickup location (Admin only)
 */
export async function updatePickupLocation(
  id: number,
  data: UpdatePickupLocationRequest
): Promise<PickupLocation> {
  const response = await apiCall<PickupLocationResponse>(`/api/pickup-locations/${id}`, {
    method: 'PUT',
    body: JSON.stringify(data),
  });

  return response.location;
}

/**
 * Delete a pickup location (Admin only)
 */
export async function deletePickupLocation(id: number): Promise<void> {
  await apiCall<void>(`/api/pickup-locations/${id}`, {
    method: 'DELETE',
  });
}
